import { fetchJson } from '@/api/client'

export type AnnotationProvider = 'claude' | 'gemini' | 'local' | 'openrouter'
export interface AnnotationSelection { provider: AnnotationProvider; model: string }
export interface AnnotationModel { id: string; label: string; available: boolean; note: string }
export interface AnnotationProviderChoice { id: AnnotationProvider; label: string; available: boolean; note: string; models: AnnotationModel[] }

export async function annotationModels(signal?: AbortSignal): Promise<{ providers: AnnotationProviderChoice[] }> {
  const result = await fetchJson<{ providers: AnnotationProviderChoice[] }>('/api/annotate/models', { signal })
  if (!Array.isArray(result.providers)) throw new Error('Could not load annotation models. Refresh to try again.')
  return result
}
